module.exports = __webpack_public_path__ + "assets/group.e83d10a1.svg";